// extracted by mini-css-extract-plugin
export default {"root":"CtVerifiedBadge_root__lVOYB","icon":"CtVerifiedBadge_icon__wZQ1P","small":"CtVerifiedBadge_small__esZ0K"};